import React, { useState } from "react";
import Table from "../component/Table1";
import moment from "moment/moment";

const HistoryPregnantVisit = ({ visit }) => {

    const [datas, setDatas] = useState(visit.pregnant_visits?.length ? visit.pregnant_visits[0] : null)
    const leopolds = [
        '',
        'Leopold 1: Keterangan TFU (sesuai system + belum bisa dinilai)',
        'Leopold 2: Punggung Kanan / Punggung Kiri',
        'Leopold 3: Presentasi Janin (Kepala/Sungsang/Obliq/Melintang/belum bisa di nilai)',
        'Leopold 4: Konvergen/Devergen',
    ]

    return (
        <>
            <div className='card' style={{ width: '100%', marginBottom: 0 }}>
                <div
                    className='card-header bg-success text-white collapsed'
                    id={"headinglabx"}
                    data-toggle='collapse'
                    data-target={"#collapselabx"}
                    aria-expanded='false'
                    aria-controls={"collapselabx"}
                >
                    <h4 className={'mb-0 text-white'}>Riwayat Pemeriksaan Kehamilan</h4>
                </div>
                <div
                    className='collapse'
                    id={"collapselabx"}
                    aria-labelledby={"headinglabx"}>
                    <div className='card-body'>
                        <div className='list-group mb-4'>
                            <div className='list-group-item mt-0 mb-0'>
                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Tanggal</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {moment(datas?.visit?.created_at).format("DD-MM-YYYY")}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Usia Kehamilan</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.age_of_pregnant + " Minggu"}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Bidan</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.doctor?.name}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Pemberian FE</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.fe_count + ' tablet'}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Leopold</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            <div>{leopolds[datas?.leopold ?? 0]}</div>
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Tinggi Fundus</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light text-left'>
                                            <div>{datas?.fundus_height} cm</div>
                                            <div>{datas?.fundus_height_explanation}</div>
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Letak Janin</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light text-left'>
                                            <div>{datas?.fetal_position}</div>
                                            <div>{datas?.head_presentation ? ('TBJ: ' + datas?.tbj + ' gram') : ''}</div>
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Denyut Jantung Bayi</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.fetal_heart_beat ? "Ada" : "Tidak Ada"}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Jumlah Denyut Jantung Bayi</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.fetal_pulse}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Edema</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.edema ?? '-'}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Patella</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.pattela ? "Positif" : "Negatif"}
                                        </button>
                                    </div>
                                </div>

                                <div className='row pb-2 pt-2 ml-1 mr-1'>
                                    <div className='col-md-4'>
                                        <span className=''>Diagnosa</span>
                                    </div>
                                    <div className='col-md-8'>
                                        <button
                                            className='btn btn-secondary border-light'>
                                            {datas?.visit?.diagnoses?.length ? datas?.visit?.diagnoses?.map((data, i) => (
                                                <div key={i}>{data.icd_code + "-" + data.icd_name}</div>
                                            )) : ''}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HistoryPregnantVisit